import { useContext, useRef } from "react";
import { Box, IconButton } from "@mui/material";
import FlippyCard from "../FlippyCard";
import { GlobalContext } from "../../../../common/Context";
import Carousel from "react-elastic-carousel";
import { useTranslation } from "react-i18next";
import {
  DriverScoreIcon,
  EventsIcon,
  MyTrypsNavIcon,
} from "../../../../common/Icons";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { background, text } from "../../../../../theme/colours";

const MobileStatCards = ({ flipLoading, flippyValues }) => {
  const { t } = useTranslation("Stats");
  const { tabletView } = useContext(GlobalContext);

  const carouselRef = useRef(null);
  const wrapperRef = useRef(null);
  const breakPoints = [{ width: 1, itemsToShow: tabletView ? 2 : 1 }];

  const flippyBox = {
    right: "2%",
    position: "relative",
    "& .rec-item-wrapper": {
      height: "100%",
      alignItems: "center",
    },
  };
  const buttonContainer = {
    display: "flex",
    justifyContent: "center",
    mt: "0.5rem",
  };
  const buttonStyle = {
    background: `${text.primary} !important`,
    width: "1.5rem",
    height: "1.5rem",
  };
  const iconStyle = {
    color: background.primary,
    fontSize: "1.25rem",
  };

  const onNextStart = (currentItem, nextItem) => {
    if (currentItem.index === nextItem.index) {
      carouselRef.current.goTo(0);
    }
  };

  const onPrevStart = (currentItem, nextItem) => {
    if (currentItem.index === nextItem.index) {
      carouselRef.current.goTo(2);
    }
  };

  return (
    <Box ref={wrapperRef} sx={flippyBox}>
      <Carousel
        ref={carouselRef}
        breakPoints={breakPoints}
        pagination={false}
        showArrows={false}
        onPrevStart={onPrevStart}
        onNextStart={onNextStart}>
        <FlippyCard
          isLoading={flipLoading}
          iconSrc={<EventsIcon />}
          title={t("myAvgEvents")}
          frontDesc={t("daily")}
          backDesc={t("eventsDesc")}
          statLine={flippyValues.avgEvents}
        />
        <FlippyCard
          isLoading={flipLoading}
          difference={flippyValues.avgDriverScore - flippyValues.lwDriverScore}
          iconSrc={<DriverScoreIcon />}
          title={t("avgDriverScore")}
          frontDesc={t("outOf100")}
          backDesc={t("avgDriverScoreDesc")}
          statLine={flippyValues.avgDriverScore}
        />
        <FlippyCard
          isLoading={flipLoading}
          iconSrc={<MyTrypsNavIcon />}
          title={t("tryps")}
          frontDesc={t("totalNumTryps")}
          backDesc={t("trypsDesc")}
          statLine={flippyValues.totalTryps}
        />
      </Carousel>
      <Box sx={buttonContainer}>
        <IconButton
          sx={{ ...buttonStyle, mr: "1rem" }}
          onClick={() => {
            carouselRef.current.slidePrev();
            carouselRef.current.onPrevStart(onPrevStart);
          }}>
          <ArrowLeftIcon sx={iconStyle} />
        </IconButton>
        <IconButton
          sx={buttonStyle}
          onClick={() => {
            carouselRef.current.slideNext();
            carouselRef.current.onNextStart(onNextStart);
          }}>
          <ArrowRightIcon sx={iconStyle} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default MobileStatCards;
